import React, {useCallback, useEffect, useState} from 'react';

//BONOS VERDES
import Layout from '../../components/admin/Layout';
import MainContent from './MainContent';

//UTILS
import {INITIAL_MAPSTYLE} from '@/config';
import {
  generateQr,
  getAvailableInitiatives,
  getCurrentPerformer,
  getInitiatives,
  interestedInInitiative
} from '@/domain/useCases/greenBonusUseCase';
import {BaseInitiative, Initiative, UUID} from '@/domain/entities/Initiative';
import {PerformerEmployee} from '@/domain/entities/PerformerEmployee';

const Index = () => {
  
  const [availableInitiatives, setAvailableInitiatives] = useState<Array<BaseInitiative> | undefined>();
  const [initiatives, setInitiatives] = useState<Array<Initiative> | undefined>();
  const [currentPerformer, setCurrentPerformer] = useState<Array<PerformerEmployee> | undefined>();

  const fetchAvailableInitatives = useCallback(() => {
    getAvailableInitiatives().then(setAvailableInitiatives);
  }, []);

  const fetchInitiatives = useCallback(() => {
    getInitiatives().then(
      res => res && setInitiatives(res.sort((a, b) => a.uuid.localeCompare(b.uuid)))
    );
  }, []);
  
  const fetchCurrentPerformer = useCallback(() => {
    getCurrentPerformer().then(setCurrentPerformer);
  }, []);

  useEffect(fetchAvailableInitatives, [fetchAvailableInitatives]);
  useEffect(fetchInitiatives, [fetchInitiatives]);
  useEffect(fetchCurrentPerformer, [fetchCurrentPerformer]);

  const [mapStyleId, setMapStyleId] = useState<string>(INITIAL_MAPSTYLE.id);

  const handleMapStyleChange = (mapStyleId: string) => setMapStyleId(mapStyleId);

  const onContact = (initiativeId: UUID) => interestedInInitiative(initiativeId).then(fetchAvailableInitatives);
  const onQrGenerate = (initiativeId: UUID) => generateQr(initiativeId).then(fetchInitiatives);

  const mainContent = <MainContent
    initiatives={initiatives}
    availableInitiatives={availableInitiatives}
    mapStyle={mapStyleId}
    mapStyleId={mapStyleId}
    onStyleChange={handleMapStyleChange}
    onContactClick={onContact}
    onQrGenerate={onQrGenerate}
    currentPerformer={currentPerformer}
  />;

  return <Layout
    mainContent={mainContent}
    currentPerformer={currentPerformer}
  />;
};

export default Index;
